module.exports = __webpack_public_path__ + "static/media/Gamevy.53632a05.jpg";